import React from "react";
import { HiOutlineChartBar, HiOutlineSquares2X2 } from "react-icons/hi2";
import { useTranslation } from "react-i18next";

const SwitchView = ({ viewMode, handleToggle }) => {
	const { t } = useTranslation();
	return (
		<div className="switch-view-container">
			<div className="switch-view">
				<input
					checked={viewMode === "chart"}
					onChange={handleToggle}
					className="react-switch-checkbox"
					id="react-switch-view"
					type="checkbox"
				/>
				<label className="react-switch-label" htmlFor="react-switch-view">
					<div
						className={`switch-icon-container ${
							viewMode === "grid" ? "active" : ""
						}`}
						title={t('plan.view.tableView')}
					>
						<HiOutlineSquares2X2
							className={`switch-icon ${viewMode === "grid" ? "active" : ""}`}
							size={18}
							strokeWidth={1.5}
						/>
					</div>
					<div
						className={`switch-icon-container ${
							viewMode === "chart" ? "active" : ""
						}`}
						title={t('plan.view.chartView')}
					>
						<HiOutlineChartBar
							className={`switch-icon ${viewMode === "chart" ? "active" : ""}`}
							size={18}
							strokeWidth={1.5}
						/>
					</div>
					<span className={`react-switch-button`} />
				</label>
			</div>
		</div>
	);
};

export default SwitchView;
